let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fJU8y")).then(() => parcelRequire('5I6Jc'));